import JobsReportPanel from "components/JobsReportPanel";

const CompanyJobsReport = () => {
  return <JobsReportPanel name="test" displayPosition />;
};

export default CompanyJobsReport;
